
import { Vue, Component, Watch } from "vue-property-decorator"
import { mapActions } from "vuex"
import api from "../honcierge-api"
import EditCategory from "@/components/EditCategory.vue"
import TableItemIsEnabled from "@/components/_share/TableItemIsEnabled.vue"
import { Category } from "types/category"
import { DataTableHeader } from "vuetify/types"
import { AxiosError } from "axios"
import { BannerType } from "types/index"

@Component({
  components: { EditCategory, TableItemIsEnabled },
  methods: {
    ...mapActions("master", ["updateBannerTypes"]),
  },
})
export default class Categories extends Vue {
  private updateBannerTypes!: (d: BannerType[]) => void
  private loading = true
  private dialog = false
  private search = ""
  private totalPages = 0
  private categories: Category["view"][] = []
  private pagination = {
    sortBy: ["priority"],
    sortDesc: [true],
    itemsPerPage: -1,
    page: 1,
  }

  get headers(): DataTableHeader[] {
    return [
      { text: "優先度", value: "priority" },
      { text: "名称", value: "name" },
      { text: "URL", value: "urlKey" },
      { text: "有効/無効", value: "isEnabled" },
      { text: "操作", value: "action", sortable: false },
    ]
  }

  public async created(): Promise<void> {
    this.getCategories()
    await this.getBannerTypes()
    this.loading = false
  }

  @Watch("pagination.page", { deep: true, immediate: true })
  private onChangePage() {
    this.loading = true
    setTimeout(() => {
      this.getCategories()
      this.loading = false
    }, 500)
  }

  private getCategories(page?: number) {
    api
      .getCategories({
        search: this.search,
        sortBy: this.pagination.sortBy[0],
        descending: true,
        page: page ? page : this.pagination.page,
        per: 10,
        includeDisabled: true,
        fields: ["id", "name", "urlKey", "priority", "isEnabled"],
      })
      .then((res) => {
        this.totalPages = res.data.meta.totalPages
        this.categories.length = 0
        this.categories = res.data.categories
      })
      .catch((e: AxiosError) => {
        console.log(e.stack)
      })
  }

  private async getBannerTypes() {
    await api.getBannerTypes().then((res) => {
      this.updateBannerTypes(res.data)
    })
  }

  private searchCategories() {
    this.resetPagination()
    this.getCategories()
  }

  private resetPagination() {
    this.pagination.page = 1
  }

  private updateCategory(category: Category["view"]) {
    const target = this.categories.find((c) => c.id === category.id)
    if (target) {
      // 更新
      target.name = category.name
      target.isEnabled = category.isEnabled
      target.urlKey = category.urlKey
      target.priority = category.priority
    } else {
      // 新規作成
      this.categories.push(category)
    }

    this.close()
  }

  private async open(item?: Category["view"]) {
    const editCategory = this.$refs.editCategory as InstanceType<
      typeof EditCategory
    >
    if (item) {
      // 更新
      editCategory.id = item.id
      try {
        const response = await api.getCategory(item.id)
        const category = response.data.category
        editCategory.name = category.name
        editCategory.isEnabled = category.isEnabled
        editCategory.urlKey = category.urlKey
        editCategory.priority = category.priority
        editCategory.bannerType = category.bannerType
        editCategory.selectedSpecialFeatures = category.specialFeatures
      } catch {
        this.$toasted.error("カテゴリーの取得に失敗しました")
        this.close()
      }
    } else {
      // 新規作成
      editCategory.id = -1
      try {
        const response = await api.getMaxPriorityForCategories()
        const maxPriority = response.data.maxPriority
        editCategory.priority = maxPriority + 10
      } catch {
        console.log("カテゴリーの最大優先度の取得に失敗")
      }
    }
    this.dialog = true
  }

  private close() {
    this.dialog = false
  }
}
